import Image from "next/image";
import React from "react";

import Courses from "./Courses";

export function MainSlider({ data, categories }: any): JSX.Element {
  return (
    <div className="relative z-10 md:-mb-28 lg:m-0">
      {/* <SwiperSlide> */}
      <div className="relative text-white">
        <img
          fetchpriority="high"
          src={data?.largeImage ?? "images/slide.png"}
          className="z-10 max-h-[500px] w-full"
          alt={data?.largeImageText ?? "slide"}
          height="500"
          width="1905"
        />
        {/*<Image*/}
        {/*  src={data?.largeImage ?? "images/slide.png"}*/}
        {/*  className="z-10 max-h-[500px] w-full"*/}
        {/*  alt={data?.largeImageText ?? "slide"}*/}
        {/*  height="500"*/}
        {/*  width="1905"*/}
        {/*  priority*/}
        {/*/>*/}
        <div
          className="absolute right-0 top-1/2 z-10 flex h-auto w-full -translate-y-1/2 flex-col justify-around bg-slate-400 py-[10px] px-[10%] md:h-32"
          style={{
            background:
              data?.firstColor ??
              "linear-gradient(270deg, rgba(54, 100, 148, 0.5) 0%, rgba(4, 128, 212, 0.5) 50%, rgba(39, 178, 188, 0.5) 100%)",
            boxShadow: "0px 0px 5px rgba(139, 139, 139, 0.19)",
          }}
        >
          <h1 className="flex text-xs font-bold md:text-[22px] lg:w-full lg:text-[35px]">
            {/* <span className="ml-1 block">دادبانان: </span> پیوند آموزش و اشتغال */}
            {data?.title}
          </h1>
          <p className="w-1/2 text-xs md:w-1/3 md:text-[15px] lg:w-full lg:text-[21px]">
            {/* مرکز آموزش‏‌های تخصصی حقوقی کاربردی و مهارت محور */}
            {data?.description}
          </p>
        </div>
        {/*<Image*/}
        {/*  src={data?.smallImage ?? "images/person.png"}*/}
        {/*  alt={data?.smallImageText ?? "person"}*/}
        {/*  width={200}*/}
        {/*  height={200}*/}
        {/*  priority*/}
        {/*  className="absolute -left-0 bottom-0 z-20 h-[95%] md:h-[90%] lg:h-[120%]"*/}
        {/*/>*/}
        <img
          fetchpriority="high"
          src={data?.smallImage ?? "images/person.png"}
          alt={data?.smallImageText ?? "person"}
          className="absolute -left-0 bottom-0 z-20 h-[95%] md:h-[90%] lg:h-[120%]"
        />
      </div>
      <Courses data={categories} />
    </div>
  );
}

export default MainSlider;
